import { gql } from '@apollo/client';

/**
 * Fragment canónico de Order — superset de los subselects usados por las
 * mutations legacy (CREATE_NEW_ORDER, UPDATE_ORDER, UPDATE_ORDER_RELATIONSHIPS).
 *
 * Se usa en la respuesta de las 5 mutations `SAVE_<ENTITY>` para que Apollo
 * normalice la celda `Order:<id>` con todos los campos que los componentes y
 * queries consumen. Ver PLAN-SAVE-ENTITY-UNIFIED.md §2.4.
 */
export const NEW_ORDER = gql`
  fragment NewOrder on Order {
    id
    roid

    # ─── Índices + estado + tipo ───
    indexExpedition
    indexType
    type
    state
    specialTag
    # Hora en que la OT entró en «cerrada» (null si no está cerrada o es
    # anterior al historial). Solo lectura.
    closedAt

    # ─── Relaciones entidad doble (qué Entity cuelga de esta Order) ───
    communicationIDs
    genericOrdersIDs
    campaignIDs
    accidentIDs
    actionIDs
    routeSegmentIDs

    # ─── Tipo B denormalizado (coherente con Entity paralela) ───
    classificationIDs
    capitolIDs
    subCapitolIDs
    concessionIDs
    roadIDs
    teamIDs
    pkInitKm
    pkInitMeter
    pkEndKm
    pkEndMeter

    # ─── Tipo C exclusivos Order (metadata transversal) ───
    description
    # Copia denormalizada de la validada de la Actuacion gemela (null en el
    # resto de tipos). Las tablas de nivel orden — Multimedia — pintan
    # 'descriptionValidated || description', que es lo mismo que pinta la tabla
    # de Actuaciones: sin esto la MISMA fila decia dos cosas segun la pantalla.
    descriptionValidated
    notes
    userId
    registeredByUserId
    creationDate
    registerInitDate
    registerEndDate
    derivedEndDate
    elementOrderIDs
    predefinedOrderIDs
    isTransferred
    imageIDs

    # ─── Jerarquía padre-hija (D0) y cross-links ───
    parentExpeditionOrderIDs
    childExpeditionOrderIDs

    # ─── Nav Trabajo/Revisión — contenedor D0 denormalizado (Fase 4 nav,
    # follow-up T4 2026-07-12): "Origen" de la tabla global de Multimedia se
    # lee directo de este campo (null en Orders D0 propias — fallback a
    # type en el selector). Ver gql/selectors/multimedia.ts.
    containerType

    # ─── Cross-links V4 surveillance route (Order↔Order self-ref) ───
    # Forward (en la Order del TRAMO): a qué Actuació/OT externa está vinculado.
    segmentLinkedBasicActionOrderIDs
    segmentLinkedExternalOrderIDs
    # Reverse (en la Order de la Actuació/OT externa): a qué tramo está
    # vinculada. P15 Fase 1 (2026-07-08) — resuelve la pill "Vinculat amb
    # Tr.NN" en ActionOT. Ver docs/superpowers/specs/2026-07-08-p15-vincular-tram-wiring-design.md.
    basicActionLinkedSegmentOrderIDs
    externalLinkedSegmentOrderIDs
  }
`;
